import React from 'react'

export default function ArrowRightIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.16699 10.0001H15.8337M15.8337 10.0001L10.0003 4.16675M15.8337 10.0001L10.0003 15.8334" stroke="#344054" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
